"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _FallbackThemeContext = require("./FallbackThemeContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// React 15.x compatibility fallback. We'll remove it later.
var ThemeContext = _constants.IS_LEGACY_CONTEXT ? _FallbackThemeContext.FallbackThemeContext : _react["default"].createContext({
  theme: 'default'
});
exports.ThemeContext = ThemeContext;